import { LogOut, Menu, User } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../../auth';
import { useOps } from '../../hooks/useOps';
import { cn } from '../../lib/utils';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

interface HeaderProps {
  onMenuClick: () => void;
  sidebarOpen: boolean;
}

export function Header({ onMenuClick, sidebarOpen }: HeaderProps) {
  const { user, logout } = useAuth();
  const { getCurrentOpsConfig } = useOps();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    setIsDropdownOpen(false);
    logout();
  };

  const currentOpsConfig = getCurrentOpsConfig();

  return (
    <header
      className={cn(
        'fixed top-0 z-50 w-full border-b border-[hsl(214,32%,91%)] bg-white/95 backdrop-blur-sm transition-all duration-200',
        sidebarOpen ? 'left-0 md:left-64' : 'left-0',
        sidebarOpen ? 'md:w-[calc(100%-16rem)]' : 'w-full'
      )}
    >
      <div className="flex h-16 items-center justify-between px-4">
        <div className="flex items-center gap-4">
          {!sidebarOpen && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onMenuClick}
              className="md:hidden text-[hsl(210,50%,10%)] hover:bg-[hsl(210,40%,96%)]"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}

          <div className="flex items-center gap-3">
            <h1 className="text-xl font-semibold text-[hsl(210,50%,10%)]">
              Dashboard
            </h1>
            {currentOpsConfig && (
              <Badge
                className="text-white font-medium"
                style={{ backgroundColor: currentOpsConfig.color }}
              >
                {currentOpsConfig.displayName}
              </Badge>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span className="hidden sm:block text-sm text-[hsl(215,16%,47%)]">
            {user?.name || user?.email}
          </span>

          <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="rounded-full hover:bg-[hsl(210,40%,96%)]"
              >
                <User className="h-5 w-5 text-[hsl(210,50%,10%)]" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              className="w-48 bg-white border-[hsl(214,32%,91%)]"
            >
              <div className="px-2 py-1.5">
                <p className="text-sm font-medium text-[hsl(210,50%,10%)]">
                  {user?.name || 'Usuário'}
                </p>
                <p className="text-xs text-[hsl(215,16%,47%)]">{user?.email}</p>
              </div>
              <DropdownMenuSeparator className="bg-[hsl(214,32%,91%)]" />
              <DropdownMenuItem
                onClick={handleLogout}
                className="text-red-600 focus:text-red-600 focus:bg-red-50 cursor-pointer"
              >
                <LogOut className="mr-2 h-4 w-4" />
                Sair
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
